import { AxiosAmbient } from 'src/lib';
import {
  getEncounterAudioSlice,
  uploadAudioSlice,
  getFileNameSlice,
} from '../slices/audio';
import { FronteggContext } from '@frontegg/rest-api';

// List encounters with search filters as query parameters
export const getAudio = (encounter_id, encounter_phase, callback) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const params = {
      encounter_id: encounter_id,
      encounter_phase: encounter_phase,
    };
    const result = await AxiosAmbient.get(`/audio/presigned_url`, {
      headers,
      params,
    });
    const response = result?.data;
    if (result?.status === 200) {
      dispatch(getEncounterAudioSlice(response));
    }
  };
};

export const uploadAudio = (encounter_id, encounter_phase, filename, file) => {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append('filename', filename);
    formData.append('encounter_id', encounter_id);
    formData.append('encounter_phase', encounter_phase);

    const headers = {
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
      // Note: Don't set Content-Type header when using FormData
      // Browser will automatically set it with the correct boundary
    };

    const result = await AxiosAmbient.post('/audio/presigned_url', formData, {
      headers,
    });

    const response = result?.data;
    if (result?.status === 200) {
      dispatch(uploadAudioSlice(response));
      return response;
    }
  };
};

export const getFileName = (encounter_id, encounter_phase) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const params = {
      encounter_id: encounter_id,
      encounter_phase: encounter_phase,
    };
    const result = await AxiosAmbient.get('/audio/filename', {
      headers,
      params,
    });
    const response = result?.data;
    if (result?.status === 200) {
      dispatch(getFileNameSlice(response));
      return response;
    }
  };
};
